export default function ProgressBar({ value }: { value: number }) {
  return (
    <div
      className="w-full h-spacing-1 bg-palette-surface-progress-bar-empty rounded-full"
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={1000}
      tabIndex={0}
      aria-label="API usage progress"
    >
      <div
        className="h-spacing-1 bg-palette-surface-progress-bar-full rounded-full"
        style={{
          width: `${Math.min(((value || 0) / 1000) * 100, 100)}%`,
        }}
      />
    </div>
  );
}
